import { GlobalMessageConfig, GlobalMessageType } from "@spartacus/core";

export const genGlobalMessageConfig: GlobalMessageConfig = {
  globalMessages: {
    [GlobalMessageType.MSG_TYPE_CONFIRMATION]: {
      timeout: 30000,
    },
    [GlobalMessageType.MSG_TYPE_INFO]: {
      timeout: 30000,
    },
    [GlobalMessageType.MSG_TYPE_ERROR]: {
      timeout: 30000,
    },
    [GlobalMessageType.MSG_TYPE_WARNING]: {
      timeout: 30000,
    },
    [GlobalMessageType.MSG_TYPE_ASSISTIVE]: {
      timeout: 30000,
    },
  },
};